import makeActionCreator from 'utils/makeActionCreator';
import { SHOW_MODAL, FORM_SENDED } from './constants';

export const showModalAction = makeActionCreator(
  SHOW_MODAL,
  'showModal',
  'url',
);
export const markAsSendedAction = makeActionCreator(FORM_SENDED, 'value');
